<template>
  <div style="min-width: 350px;">
    <date-range-picker
      ref="picker"
      :opens="opens"
      :locale-data="localeData"
      :minDate="minDate"
      :maxDate="maxDate"
      :singleDatePicker="singleDatePicker"
      :timePicker="timePicker"
      :timePicker24Hour="timePicker24Hour"
      :showWeekNumbers="showWeekNumbers"
      :showDropdowns="showDropdowns"
      :autoApply="autoApply"
      :value="dateRange"  
      @input="onInput"  
      @toggle="logEvent('event: open', $event)"
      @start-selection="logEvent('event: startSelection', $event)"
      @finish-selection="logEvent('event: finishSelection', $event)"
      :linkedCalendars="linkedCalendars"
      :dateFormat="dateFormat"
    >
      <template v-slot:input="picker">
        {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
      </template>
    </date-range-picker>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';

export default {
  components: {
    DateRangePicker,
  },
  props: {
    minDate: {
      type: Date,
      default: () => new Date(),
    },
    maxDate: {
      type: Date,
      default: () => new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    },
    dateRange: {
      type: Array,
      default: () => [new Date(), new Date()], // Ensure default value is an array with two dates
    },
  },
  data() {
    return {
      singleDatePicker: false,
      timePicker: false,
      timePicker24Hour: false,
      showWeekNumbers: false,
      showDropdowns: true,
      autoApply: false,
      linkedCalendars: true,
      dateFormat: 'DD/MM/YYYY',
      opens: 'right',
      localeData: {
        firstDay: 1,
        format: 'dd-mm-yyyy',
      },
    };
  },
  methods: {
    onInput(newDateRange) {
      this.$emit('update:dateRange', newDateRange); 
    },
    logEvent(event, payload) {
      console.log(event, payload);
    },
    formatDate(date) {
      return moment(date).format(this.dateFormat); 
    },
  },
};
</script>
